// source: io/codedrills/proto/judge/judge.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_content_content_visibility_pb = require('../../../../io/codedrills/proto/content/content_visibility_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_content_visibility_pb);
goog.exportSymbol('proto.io.codedrills.proto.judge.Arg', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.ArgType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.ArgType.TypeCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.ArgView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.CompileRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.CompileResult', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.CompositeType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.Difficulty', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.EvaluationType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.IOType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.JudgeSettings', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.Language', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.LibraryInfo', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.MethodDef', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.NestedType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.PrimitiveType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.Problem', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.ProblemConstraints', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.ProblemKey', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.ProblemMeta', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.ProblemStats', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.ProblemType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.Rejudge', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.RejudgeStatus', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.RejudgeSubmission', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.SqlInfo', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.Status', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.Submission', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.SubmissionSummary', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.SubmissionType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestCase.InputCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestCase.OutputCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestInputView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestKey', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestOutputView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestResult', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestResultView', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestRunRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestRunResult', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestSet', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.TestTag', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.WrappedIO', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.Problem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.Problem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.Problem.displayName = 'proto.io.codedrills.proto.judge.Problem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.TestSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.TestSet.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.TestSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.TestSet.displayName = 'proto.io.codedrills.proto.judge.TestSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.TestCase = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.TestCase.repeatedFields_, proto.io.codedrills.proto.judge.TestCase.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.judge.TestCase, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.TestCase.displayName = 'proto.io.codedrills.proto.judge.TestCase';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.ProblemMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.ProblemMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.ProblemMeta.displayName = 'proto.io.codedrills.proto.judge.ProblemMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.WrappedIO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.WrappedIO.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.WrappedIO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.WrappedIO.displayName = 'proto.io.codedrills.proto.judge.WrappedIO';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.MethodDef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.MethodDef.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.MethodDef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.MethodDef.displayName = 'proto.io.codedrills.proto.judge.MethodDef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.ProblemConstraints = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.ProblemConstraints, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.ProblemConstraints.displayName = 'proto.io.codedrills.proto.judge.ProblemConstraints';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.ProblemStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.ProblemStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.ProblemStats.displayName = 'proto.io.codedrills.proto.judge.ProblemStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.JudgeSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.JudgeSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.JudgeSettings.displayName = 'proto.io.codedrills.proto.judge.JudgeSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.SqlInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.SqlInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.SqlInfo.displayName = 'proto.io.codedrills.proto.judge.SqlInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.LibraryInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.LibraryInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.LibraryInfo.displayName = 'proto.io.codedrills.proto.judge.LibraryInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.TestResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.TestResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.TestResult.displayName = 'proto.io.codedrills.proto.judge.TestResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.Arg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.Arg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.Arg.displayName = 'proto.io.codedrills.proto.judge.Arg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.ArgType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.judge.ArgType.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.judge.ArgType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.ArgType.displayName = 'proto.io.codedrills.proto.judge.ArgType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.NestedType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.NestedType.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.NestedType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.NestedType.displayName = 'proto.io.codedrills.proto.judge.NestedType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.ProblemKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.ProblemKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.ProblemKey.displayName = 'proto.io.codedrills.proto.judge.ProblemKey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.TestKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.TestKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.TestKey.displayName = 'proto.io.codedrills.proto.judge.TestKey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.CompileResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.CompileResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.CompileResult.displayName = 'proto.io.codedrills.proto.judge.CompileResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.TestRunRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.TestRunRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.TestRunRequest.displayName = 'proto.io.codedrills.proto.judge.TestRunRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.TestRunResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.TestRunResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.TestRunResult.displayName = 'proto.io.codedrills.proto.judge.TestRunResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.Submission = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.Submission, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.Submission.displayName = 'proto.io.codedrills.proto.judge.Submission';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.SubmissionSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.SubmissionSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.SubmissionSummary.displayName = 'proto.io.codedrills.proto.judge.SubmissionSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.CompileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.CompileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.CompileRequest.displayName = 'proto.io.codedrills.proto.judge.CompileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.Rejudge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.Rejudge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.Rejudge.displayName = 'proto.io.codedrills.proto.judge.Rejudge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.TestResultView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.TestResultView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.TestResultView.displayName = 'proto.io.codedrills.proto.judge.TestResultView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.TestOutputView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.TestOutputView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.TestOutputView.displayName = 'proto.io.codedrills.proto.judge.TestOutputView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.TestInputView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.TestInputView.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.TestInputView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.TestInputView.displayName = 'proto.io.codedrills.proto.judge.TestInputView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.ArgView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.ArgView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.ArgView.displayName = 'proto.io.codedrills.proto.judge.ArgView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.RejudgeSubmission = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.RejudgeSubmission, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.RejudgeSubmission.displayName = 'proto.io.codedrills.proto.judge.RejudgeSubmission';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.Problem.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.Problem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.Problem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.Problem.toObject = function(includeInstance, msg) {
  var f, obj = {
    statement: jspb.Message.getFieldWithDefault(msg, 1, ""),
    editorial: jspb.Message.getFieldWithDefault(msg, 2, ""),
    testSetsMap: (f = msg.getTestSetsMap()) ? f.toObject(includeInstance, proto.io.codedrills.proto.judge.TestSet.toObject) : [],
    judgeSettings: (f = msg.getJudgeSettings()) && proto.io.codedrills.proto.judge.JudgeSettings.toObject(includeInstance, f),
    statementView: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sqlInfo: (f = msg.getSqlInfo()) && proto.io.codedrills.proto.judge.SqlInfo.toObject(includeInstance, f),
    libraryInfo: (f = msg.getLibraryInfo()) && proto.io.codedrills.proto.judge.LibraryInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.Problem}
 */
proto.io.codedrills.proto.judge.Problem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.Problem;
  return proto.io.codedrills.proto.judge.Problem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.Problem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.Problem}
 */
proto.io.codedrills.proto.judge.Problem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatement(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEditorial(value);
      break;
    case 3:
      var value = msg.getTestSetsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.io.codedrills.proto.judge.TestSet.deserializeBinaryFromReader, "", new proto.io.codedrills.proto.judge.TestSet());
         });
      break;
    case 4:
      var value = new proto.io.codedrills.proto.judge.JudgeSettings;
      reader.readMessage(value,proto.io.codedrills.proto.judge.JudgeSettings.deserializeBinaryFromReader);
      msg.setJudgeSettings(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementView(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.judge.SqlInfo;
      reader.readMessage(value,proto.io.codedrills.proto.judge.SqlInfo.deserializeBinaryFromReader);
      msg.setSqlInfo(value);
      break;
    case 7:
      var value = new proto.io.codedrills.proto.judge.LibraryInfo;
      reader.readMessage(value,proto.io.codedrills.proto.judge.LibraryInfo.deserializeBinaryFromReader);
      msg.setLibraryInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.Problem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.Problem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.Problem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.Problem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatement();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEditorial();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTestSetsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.io.codedrills.proto.judge.TestSet.serializeBinaryToWriter);
  }
  f = message.getJudgeSettings();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.io.codedrills.proto.judge.JudgeSettings.serializeBinaryToWriter
    );
  }
  f = message.getStatementView();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSqlInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.judge.SqlInfo.serializeBinaryToWriter
    );
  }
  f = message.getLibraryInfo();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.io.codedrills.proto.judge.LibraryInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string statement = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.Problem.prototype.getStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
 */
proto.io.codedrills.proto.judge.Problem.prototype.setStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string editorial = 2;
 * @return {string}
 */
proto.io.codedrills.proto.judge.Problem.prototype.getEditorial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
 */
proto.io.codedrills.proto.judge.Problem.prototype.setEditorial = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, TestSet> test_sets = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.io.codedrills.proto.judge.TestSet>}
 */
proto.io.codedrills.proto.judge.Problem.prototype.getTestSetsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.io.codedrills.proto.judge.TestSet>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.io.codedrills.proto.judge.TestSet));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
 */
proto.io.codedrills.proto.judge.Problem.prototype.clearTestSetsMap = function() {
  this.getTestSetsMap().clear();
  return this;};


/**
 * optional JudgeSettings judge_settings = 4;
 * @return {?proto.io.codedrills.proto.judge.JudgeSettings}
 */
proto.io.codedrills.proto.judge.Problem.prototype.getJudgeSettings = function() {
  return /** @type{?proto.io.codedrills.proto.judge.JudgeSettings} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.JudgeSettings, 4));
};


/**
 * @param {?proto.io.codedrills.proto.judge.JudgeSettings|undefined} value
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
*/
proto.io.codedrills.proto.judge.Problem.prototype.setJudgeSettings = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
 */
proto.io.codedrills.proto.judge.Problem.prototype.clearJudgeSettings = function() {
  return this.setJudgeSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.Problem.prototype.hasJudgeSettings = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string statement_view = 5;
 * @return {string}
 */
proto.io.codedrills.proto.judge.Problem.prototype.getStatementView = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
 */
proto.io.codedrills.proto.judge.Problem.prototype.setStatementView = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional SqlInfo sql_info = 6;
 * @return {?proto.io.codedrills.proto.judge.SqlInfo}
 */
proto.io.codedrills.proto.judge.Problem.prototype.getSqlInfo = function() {
  return /** @type{?proto.io.codedrills.proto.judge.SqlInfo} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.SqlInfo, 6));
};


/**
 * @param {?proto.io.codedrills.proto.judge.SqlInfo|undefined} value
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
*/
proto.io.codedrills.proto.judge.Problem.prototype.setSqlInfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
 */
proto.io.codedrills.proto.judge.Problem.prototype.clearSqlInfo = function() {
  return this.setSqlInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.Problem.prototype.hasSqlInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional LibraryInfo library_info = 7;
 * @return {?proto.io.codedrills.proto.judge.LibraryInfo}
 */
proto.io.codedrills.proto.judge.Problem.prototype.getLibraryInfo = function() {
  return /** @type{?proto.io.codedrills.proto.judge.LibraryInfo} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.LibraryInfo, 7));
};


/**
 * @param {?proto.io.codedrills.proto.judge.LibraryInfo|undefined} value
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
*/
proto.io.codedrills.proto.judge.Problem.prototype.setLibraryInfo = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.Problem} returns this
 */
proto.io.codedrills.proto.judge.Problem.prototype.clearLibraryInfo = function() {
  return this.setLibraryInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.Problem.prototype.hasLibraryInfo = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.TestSet.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.TestSet.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.TestSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.TestSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    testsList: jspb.Message.toObjectList(msg.getTestsList(),
    proto.io.codedrills.proto.judge.TestCase.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.TestSet}
 */
proto.io.codedrills.proto.judge.TestSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.TestSet;
  return proto.io.codedrills.proto.judge.TestSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.TestSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.TestSet}
 */
proto.io.codedrills.proto.judge.TestSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.judge.TestCase;
      reader.readMessage(value,proto.io.codedrills.proto.judge.TestCase.deserializeBinaryFromReader);
      msg.addTests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.TestSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.TestSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.TestSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.io.codedrills.proto.judge.TestCase.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TestCase tests = 1;
 * @return {!Array<!proto.io.codedrills.proto.judge.TestCase>}
 */
proto.io.codedrills.proto.judge.TestSet.prototype.getTestsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.TestCase>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.judge.TestCase, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.TestCase>} value
 * @return {!proto.io.codedrills.proto.judge.TestSet} returns this
*/
proto.io.codedrills.proto.judge.TestSet.prototype.setTestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.TestCase=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.TestCase}
 */
proto.io.codedrills.proto.judge.TestSet.prototype.addTests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.judge.TestCase, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.TestSet} returns this
 */
proto.io.codedrills.proto.judge.TestSet.prototype.clearTestsList = function() {
  return this.setTestsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.TestCase.repeatedFields_ = [6];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.judge.TestCase.oneofGroups_ = [[2,3],[4,5]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.TestCase.InputCase = {
  INPUT_NOT_SET: 0,
  INPUT_STRING: 2,
  INPUT_ID: 3
};

/**
 * @return {proto.io.codedrills.proto.judge.TestCase.InputCase}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.getInputCase = function() {
  return /** @type {proto.io.codedrills.proto.judge.TestCase.InputCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.TestCase.OutputCase = {
  OUTPUT_NOT_SET: 0,
  OUTPUT_STRING: 4,
  OUTPUT_ID: 5
};

/**
 * @return {proto.io.codedrills.proto.judge.TestCase.OutputCase}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.getOutputCase = function() {
  return /** @type {proto.io.codedrills.proto.judge.TestCase.OutputCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.TestCase.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.TestCase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestCase.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    inputString: jspb.Message.getFieldWithDefault(msg, 2, ""),
    inputId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    outputString: jspb.Message.getFieldWithDefault(msg, 4, ""),
    outputId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.TestCase}
 */
proto.io.codedrills.proto.judge.TestCase.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.TestCase;
  return proto.io.codedrills.proto.judge.TestCase.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.TestCase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.TestCase}
 */
proto.io.codedrills.proto.judge.TestCase.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInputString(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInputId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutputString(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutputId(value);
      break;
    case 6:
      var value = /** @type {!Array<!proto.io.codedrills.proto.judge.TestTag>} */ (reader.readPackedEnum());
      msg.setTagsList(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.TestCase.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.TestCase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestCase.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string input_string = 2;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.getInputString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.setInputString = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.clearInputString = function() {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.hasInputString = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string input_id = 3;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.getInputId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.setInputId = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.clearInputId = function() {
  return jspb.Message.setOneofField(this, 3, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.hasInputId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string output_string = 4;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.getOutputString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.setOutputString = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.clearOutputString = function() {
  return jspb.Message.setOneofField(this, 4, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.hasOutputString = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string output_id = 5;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.getOutputId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.setOutputId = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.clearOutputId = function() {
  return jspb.Message.setOneofField(this, 5, proto.io.codedrills.proto.judge.TestCase.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.hasOutputId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated TestTag tags = 6;
 * @return {!Array<!proto.io.codedrills.proto.judge.TestTag>}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.getTagsList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.judge.TestTag>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.TestTag>} value
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.judge.TestTag} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional double score = 7;
 * @return {number}
 */
proto.io.codedrills.proto.judge.TestCase.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.TestCase} returns this
 */
proto.io.codedrills.proto.judge.TestCase.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.ProblemMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.ProblemMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ProblemMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    problemStats: (f = msg.getProblemStats()) && proto.io.codedrills.proto.judge.ProblemStats.toObject(includeInstance, f),
    ioType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    constraints: (f = msg.getConstraints()) && proto.io.codedrills.proto.judge.ProblemConstraints.toObject(includeInstance, f),
    wrappedIo: (f = msg.getWrappedIo()) && proto.io.codedrills.proto.judge.WrappedIO.toObject(includeInstance, f),
    evaluationType: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta}
 */
proto.io.codedrills.proto.judge.ProblemMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.ProblemMeta;
  return proto.io.codedrills.proto.judge.ProblemMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.ProblemMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta}
 */
proto.io.codedrills.proto.judge.ProblemMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.judge.ProblemType} */ (reader.readEnum());
      msg.setProblemType(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.judge.ProblemStats;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ProblemStats.deserializeBinaryFromReader);
      msg.setProblemStats(value);
      break;
    case 7:
      var value = /** @type {!proto.io.codedrills.proto.judge.IOType} */ (reader.readEnum());
      msg.setIoType(value);
      break;
    case 8:
      var value = new proto.io.codedrills.proto.judge.ProblemConstraints;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ProblemConstraints.deserializeBinaryFromReader);
      msg.setConstraints(value);
      break;
    case 9:
      var value = new proto.io.codedrills.proto.judge.WrappedIO;
      reader.readMessage(value,proto.io.codedrills.proto.judge.WrappedIO.deserializeBinaryFromReader);
      msg.setWrappedIo(value);
      break;
    case 10:
      var value = /** @type {!proto.io.codedrills.proto.judge.EvaluationType} */ (reader.readEnum());
      msg.setEvaluationType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.ProblemMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.ProblemMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ProblemMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getProblemStats();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.judge.ProblemStats.serializeBinaryToWriter
    );
  }
  f = message.getIoType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getConstraints();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.io.codedrills.proto.judge.ProblemConstraints.serializeBinaryToWriter
    );
  }
  f = message.getWrappedIo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.io.codedrills.proto.judge.WrappedIO.serializeBinaryToWriter
    );
  }
  f = message.getEvaluationType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * optional ProblemType problem_type = 5;
 * @return {!proto.io.codedrills.proto.judge.ProblemType}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.getProblemType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.ProblemType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.ProblemType} value
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta} returns this
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.setProblemType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional ProblemStats problem_stats = 6;
 * @return {?proto.io.codedrills.proto.judge.ProblemStats}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.getProblemStats = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ProblemStats} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ProblemStats, 6));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ProblemStats|undefined} value
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta} returns this
*/
proto.io.codedrills.proto.judge.ProblemMeta.prototype.setProblemStats = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta} returns this
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.clearProblemStats = function() {
  return this.setProblemStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.hasProblemStats = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional IOType io_type = 7;
 * @return {!proto.io.codedrills.proto.judge.IOType}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.getIoType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.IOType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.IOType} value
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta} returns this
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.setIoType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional ProblemConstraints constraints = 8;
 * @return {?proto.io.codedrills.proto.judge.ProblemConstraints}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.getConstraints = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ProblemConstraints} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ProblemConstraints, 8));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ProblemConstraints|undefined} value
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta} returns this
*/
proto.io.codedrills.proto.judge.ProblemMeta.prototype.setConstraints = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta} returns this
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.clearConstraints = function() {
  return this.setConstraints(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.hasConstraints = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional WrappedIO wrapped_io = 9;
 * @return {?proto.io.codedrills.proto.judge.WrappedIO}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.getWrappedIo = function() {
  return /** @type{?proto.io.codedrills.proto.judge.WrappedIO} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.WrappedIO, 9));
};


/**
 * @param {?proto.io.codedrills.proto.judge.WrappedIO|undefined} value
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta} returns this
*/
proto.io.codedrills.proto.judge.ProblemMeta.prototype.setWrappedIo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta} returns this
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.clearWrappedIo = function() {
  return this.setWrappedIo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.hasWrappedIo = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional EvaluationType evaluation_type = 10;
 * @return {!proto.io.codedrills.proto.judge.EvaluationType}
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.getEvaluationType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.EvaluationType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.EvaluationType} value
 * @return {!proto.io.codedrills.proto.judge.ProblemMeta} returns this
 */
proto.io.codedrills.proto.judge.ProblemMeta.prototype.setEvaluationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.WrappedIO.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.WrappedIO.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.WrappedIO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.WrappedIO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.WrappedIO.toObject = function(includeInstance, msg) {
  var f, obj = {
    className: jspb.Message.getFieldWithDefault(msg, 1, ""),
    methodsList: jspb.Message.toObjectList(msg.getMethodsList(),
    proto.io.codedrills.proto.judge.MethodDef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.WrappedIO}
 */
proto.io.codedrills.proto.judge.WrappedIO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.WrappedIO;
  return proto.io.codedrills.proto.judge.WrappedIO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.WrappedIO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.WrappedIO}
 */
proto.io.codedrills.proto.judge.WrappedIO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClassName(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.MethodDef;
      reader.readMessage(value,proto.io.codedrills.proto.judge.MethodDef.deserializeBinaryFromReader);
      msg.addMethods(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.WrappedIO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.WrappedIO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.WrappedIO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.WrappedIO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClassName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.MethodDef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string class_name = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.WrappedIO.prototype.getClassName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.WrappedIO} returns this
 */
proto.io.codedrills.proto.judge.WrappedIO.prototype.setClassName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated MethodDef methods = 2;
 * @return {!Array<!proto.io.codedrills.proto.judge.MethodDef>}
 */
proto.io.codedrills.proto.judge.WrappedIO.prototype.getMethodsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.MethodDef>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.judge.MethodDef, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.MethodDef>} value
 * @return {!proto.io.codedrills.proto.judge.WrappedIO} returns this
*/
proto.io.codedrills.proto.judge.WrappedIO.prototype.setMethodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.MethodDef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.MethodDef}
 */
proto.io.codedrills.proto.judge.WrappedIO.prototype.addMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.judge.MethodDef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.WrappedIO} returns this
 */
proto.io.codedrills.proto.judge.WrappedIO.prototype.clearMethodsList = function() {
  return this.setMethodsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.MethodDef.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.MethodDef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.MethodDef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.MethodDef.toObject = function(includeInstance, msg) {
  var f, obj = {
    methodName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    returnType: (f = msg.getReturnType()) && proto.io.codedrills.proto.judge.ArgType.toObject(includeInstance, f),
    argsList: jspb.Message.toObjectList(msg.getArgsList(),
    proto.io.codedrills.proto.judge.Arg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.MethodDef}
 */
proto.io.codedrills.proto.judge.MethodDef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.MethodDef;
  return proto.io.codedrills.proto.judge.MethodDef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.MethodDef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.MethodDef}
 */
proto.io.codedrills.proto.judge.MethodDef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethodName(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.ArgType;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ArgType.deserializeBinaryFromReader);
      msg.setReturnType(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.judge.Arg;
      reader.readMessage(value,proto.io.codedrills.proto.judge.Arg.deserializeBinaryFromReader);
      msg.addArgs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.MethodDef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.MethodDef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.MethodDef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMethodName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReturnType();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.ArgType.serializeBinaryToWriter
    );
  }
  f = message.getArgsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.judge.Arg.serializeBinaryToWriter
    );
  }
};


/**
 * optional string method_name = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.getMethodName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.MethodDef} returns this
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.setMethodName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ArgType return_type = 2;
 * @return {?proto.io.codedrills.proto.judge.ArgType}
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.getReturnType = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ArgType} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ArgType, 2));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ArgType|undefined} value
 * @return {!proto.io.codedrills.proto.judge.MethodDef} returns this
*/
proto.io.codedrills.proto.judge.MethodDef.prototype.setReturnType = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.MethodDef} returns this
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.clearReturnType = function() {
  return this.setReturnType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.hasReturnType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Arg args = 3;
 * @return {!Array<!proto.io.codedrills.proto.judge.Arg>}
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.getArgsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.Arg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.judge.Arg, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.Arg>} value
 * @return {!proto.io.codedrills.proto.judge.MethodDef} returns this
*/
proto.io.codedrills.proto.judge.MethodDef.prototype.setArgsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.Arg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.Arg}
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.addArgs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.judge.Arg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.MethodDef} returns this
 */
proto.io.codedrills.proto.judge.MethodDef.prototype.clearArgsList = function() {
  return this.setArgsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.ProblemConstraints.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.ProblemConstraints} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ProblemConstraints.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeLimitInMs: jspb.Message.getFieldWithDefault(msg, 1, 0),
    memoryLimitInKb: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sourceLimitInBytes: jspb.Message.getFieldWithDefault(msg, 3, 0),
    outputLimitInKb: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.ProblemConstraints}
 */
proto.io.codedrills.proto.judge.ProblemConstraints.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.ProblemConstraints;
  return proto.io.codedrills.proto.judge.ProblemConstraints.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.ProblemConstraints} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.ProblemConstraints}
 */
proto.io.codedrills.proto.judge.ProblemConstraints.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeLimitInMs(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemoryLimitInKb(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSourceLimitInBytes(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOutputLimitInKb(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.ProblemConstraints.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.ProblemConstraints} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ProblemConstraints.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeLimitInMs();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMemoryLimitInKb();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSourceLimitInBytes();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getOutputLimitInKb();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 time_limit_in_ms = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.getTimeLimitInMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemConstraints} returns this
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.setTimeLimitInMs = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 memory_limit_in_kb = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.getMemoryLimitInKb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemConstraints} returns this
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.setMemoryLimitInKb = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 source_limit_in_bytes = 3;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.getSourceLimitInBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemConstraints} returns this
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.setSourceLimitInBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 output_limit_in_kb = 4;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.getOutputLimitInKb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemConstraints} returns this
 */
proto.io.codedrills.proto.judge.ProblemConstraints.prototype.setOutputLimitInKb = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.ProblemStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.ProblemStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ProblemStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    difficulty: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accuracy: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    frequency: jspb.Message.getFieldWithDefault(msg, 3, 0),
    solved: jspb.Message.getFieldWithDefault(msg, 4, 0),
    attempted: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.ProblemStats}
 */
proto.io.codedrills.proto.judge.ProblemStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.ProblemStats;
  return proto.io.codedrills.proto.judge.ProblemStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.ProblemStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.ProblemStats}
 */
proto.io.codedrills.proto.judge.ProblemStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.judge.Difficulty} */ (reader.readEnum());
      msg.setDifficulty(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAccuracy(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrequency(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSolved(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttempted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.ProblemStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.ProblemStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ProblemStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDifficulty();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAccuracy();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getFrequency();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSolved();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAttempted();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional Difficulty difficulty = 1;
 * @return {!proto.io.codedrills.proto.judge.Difficulty}
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.getDifficulty = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Difficulty} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Difficulty} value
 * @return {!proto.io.codedrills.proto.judge.ProblemStats} returns this
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double accuracy = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.getAccuracy = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemStats} returns this
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.setAccuracy = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 frequency = 3;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.getFrequency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemStats} returns this
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.setFrequency = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 solved = 4;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.getSolved = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemStats} returns this
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.setSolved = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 attempted = 5;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.getAttempted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemStats} returns this
 */
proto.io.codedrills.proto.judge.ProblemStats.prototype.setAttempted = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.JudgeSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.JudgeSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.JudgeSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.JudgeSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    verifier: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.JudgeSettings}
 */
proto.io.codedrills.proto.judge.JudgeSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.JudgeSettings;
  return proto.io.codedrills.proto.judge.JudgeSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.JudgeSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.JudgeSettings}
 */
proto.io.codedrills.proto.judge.JudgeSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerifier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.JudgeSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.JudgeSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.JudgeSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.JudgeSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string verifier = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.JudgeSettings.prototype.getVerifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.JudgeSettings} returns this
 */
proto.io.codedrills.proto.judge.JudgeSettings.prototype.setVerifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.SqlInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.SqlInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.SqlInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.SqlInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    sqlInit: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.SqlInfo}
 */
proto.io.codedrills.proto.judge.SqlInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.SqlInfo;
  return proto.io.codedrills.proto.judge.SqlInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.SqlInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.SqlInfo}
 */
proto.io.codedrills.proto.judge.SqlInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSqlInit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.SqlInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.SqlInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.SqlInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.SqlInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSqlInit();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string sql_init = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.SqlInfo.prototype.getSqlInit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.SqlInfo} returns this
 */
proto.io.codedrills.proto.judge.SqlInfo.prototype.setSqlInit = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.LibraryInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.LibraryInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.LibraryInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.LibraryInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    libraryInit: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.LibraryInfo}
 */
proto.io.codedrills.proto.judge.LibraryInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.LibraryInfo;
  return proto.io.codedrills.proto.judge.LibraryInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.LibraryInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.LibraryInfo}
 */
proto.io.codedrills.proto.judge.LibraryInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLibraryInit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.LibraryInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.LibraryInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.LibraryInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.LibraryInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLibraryInit();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string library_init = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.LibraryInfo.prototype.getLibraryInit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.LibraryInfo} returns this
 */
proto.io.codedrills.proto.judge.LibraryInfo.prototype.setLibraryInit = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.TestResult.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.TestResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.TestResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    testKey: (f = msg.getTestKey()) && proto.io.codedrills.proto.judge.TestKey.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    stdout: jspb.Message.getFieldWithDefault(msg, 3, ""),
    stderr: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.TestResult}
 */
proto.io.codedrills.proto.judge.TestResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.TestResult;
  return proto.io.codedrills.proto.judge.TestResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.TestResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.TestResult}
 */
proto.io.codedrills.proto.judge.TestResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.judge.TestKey;
      reader.readMessage(value,proto.io.codedrills.proto.judge.TestKey.deserializeBinaryFromReader);
      msg.setTestKey(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStdout(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStderr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.TestResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.TestResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.TestResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestKey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.judge.TestKey.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStdout();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStderr();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional TestKey test_key = 1;
 * @return {?proto.io.codedrills.proto.judge.TestKey}
 */
proto.io.codedrills.proto.judge.TestResult.prototype.getTestKey = function() {
  return /** @type{?proto.io.codedrills.proto.judge.TestKey} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.TestKey, 1));
};


/**
 * @param {?proto.io.codedrills.proto.judge.TestKey|undefined} value
 * @return {!proto.io.codedrills.proto.judge.TestResult} returns this
*/
proto.io.codedrills.proto.judge.TestResult.prototype.setTestKey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestResult} returns this
 */
proto.io.codedrills.proto.judge.TestResult.prototype.clearTestKey = function() {
  return this.setTestKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestResult.prototype.hasTestKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Status status = 2;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.judge.TestResult.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.judge.TestResult} returns this
 */
proto.io.codedrills.proto.judge.TestResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string stdout = 3;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestResult.prototype.getStdout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestResult} returns this
 */
proto.io.codedrills.proto.judge.TestResult.prototype.setStdout = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string stderr = 4;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestResult.prototype.getStderr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestResult} returns this
 */
proto.io.codedrills.proto.judge.TestResult.prototype.setStderr = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.Arg.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.Arg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.Arg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.Arg.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: (f = msg.getType()) && proto.io.codedrills.proto.judge.ArgType.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.Arg}
 */
proto.io.codedrills.proto.judge.Arg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.Arg;
  return proto.io.codedrills.proto.judge.Arg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.Arg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.Arg}
 */
proto.io.codedrills.proto.judge.Arg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.judge.ArgType;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ArgType.deserializeBinaryFromReader);
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.Arg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.Arg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.Arg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.Arg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.judge.ArgType.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ArgType type = 1;
 * @return {?proto.io.codedrills.proto.judge.ArgType}
 */
proto.io.codedrills.proto.judge.Arg.prototype.getType = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ArgType} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ArgType, 1));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ArgType|undefined} value
 * @return {!proto.io.codedrills.proto.judge.Arg} returns this
*/
proto.io.codedrills.proto.judge.Arg.prototype.setType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.Arg} returns this
 */
proto.io.codedrills.proto.judge.Arg.prototype.clearType = function() {
  return this.setType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.Arg.prototype.hasType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.judge.Arg.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.Arg} returns this
 */
proto.io.codedrills.proto.judge.Arg.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.judge.ArgType.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.ArgType.TypeCase = {
  TYPE_NOT_SET: 0,
  PRIMITIVE_TYPE: 1,
  NESTED_TYPE: 2
};

/**
 * @return {proto.io.codedrills.proto.judge.ArgType.TypeCase}
 */
proto.io.codedrills.proto.judge.ArgType.prototype.getTypeCase = function() {
  return /** @type {proto.io.codedrills.proto.judge.ArgType.TypeCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.judge.ArgType.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.ArgType.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.ArgType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.ArgType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ArgType.toObject = function(includeInstance, msg) {
  var f, obj = {
    primitiveType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nestedType: (f = msg.getNestedType()) && proto.io.codedrills.proto.judge.NestedType.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.ArgType}
 */
proto.io.codedrills.proto.judge.ArgType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.ArgType;
  return proto.io.codedrills.proto.judge.ArgType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.ArgType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.ArgType}
 */
proto.io.codedrills.proto.judge.ArgType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.judge.PrimitiveType} */ (reader.readEnum());
      msg.setPrimitiveType(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.NestedType;
      reader.readMessage(value,proto.io.codedrills.proto.judge.NestedType.deserializeBinaryFromReader);
      msg.setNestedType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.ArgType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.ArgType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.ArgType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ArgType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.io.codedrills.proto.judge.PrimitiveType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNestedType();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.NestedType.serializeBinaryToWriter
    );
  }
};


/**
 * optional PrimitiveType primitive_type = 1;
 * @return {!proto.io.codedrills.proto.judge.PrimitiveType}
 */
proto.io.codedrills.proto.judge.ArgType.prototype.getPrimitiveType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.PrimitiveType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.PrimitiveType} value
 * @return {!proto.io.codedrills.proto.judge.ArgType} returns this
 */
proto.io.codedrills.proto.judge.ArgType.prototype.setPrimitiveType = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.judge.ArgType.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.ArgType} returns this
 */
proto.io.codedrills.proto.judge.ArgType.prototype.clearPrimitiveType = function() {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.judge.ArgType.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.ArgType.prototype.hasPrimitiveType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NestedType nested_type = 2;
 * @return {?proto.io.codedrills.proto.judge.NestedType}
 */
proto.io.codedrills.proto.judge.ArgType.prototype.getNestedType = function() {
  return /** @type{?proto.io.codedrills.proto.judge.NestedType} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.NestedType, 2));
};


/**
 * @param {?proto.io.codedrills.proto.judge.NestedType|undefined} value
 * @return {!proto.io.codedrills.proto.judge.ArgType} returns this
*/
proto.io.codedrills.proto.judge.ArgType.prototype.setNestedType = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.io.codedrills.proto.judge.ArgType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.ArgType} returns this
 */
proto.io.codedrills.proto.judge.ArgType.prototype.clearNestedType = function() {
  return this.setNestedType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.ArgType.prototype.hasNestedType = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.NestedType.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.NestedType.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.NestedType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.NestedType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.NestedType.toObject = function(includeInstance, msg) {
  var f, obj = {
    outerType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    innerTypesList: jspb.Message.toObjectList(msg.getInnerTypesList(),
    proto.io.codedrills.proto.judge.ArgType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.NestedType}
 */
proto.io.codedrills.proto.judge.NestedType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.NestedType;
  return proto.io.codedrills.proto.judge.NestedType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.NestedType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.NestedType}
 */
proto.io.codedrills.proto.judge.NestedType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.judge.CompositeType} */ (reader.readEnum());
      msg.setOuterType(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.ArgType;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ArgType.deserializeBinaryFromReader);
      msg.addInnerTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.NestedType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.NestedType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.NestedType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.NestedType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOuterType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getInnerTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.ArgType.serializeBinaryToWriter
    );
  }
};


/**
 * optional CompositeType outer_type = 1;
 * @return {!proto.io.codedrills.proto.judge.CompositeType}
 */
proto.io.codedrills.proto.judge.NestedType.prototype.getOuterType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.CompositeType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.CompositeType} value
 * @return {!proto.io.codedrills.proto.judge.NestedType} returns this
 */
proto.io.codedrills.proto.judge.NestedType.prototype.setOuterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated ArgType inner_types = 2;
 * @return {!Array<!proto.io.codedrills.proto.judge.ArgType>}
 */
proto.io.codedrills.proto.judge.NestedType.prototype.getInnerTypesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.ArgType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.judge.ArgType, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.ArgType>} value
 * @return {!proto.io.codedrills.proto.judge.NestedType} returns this
*/
proto.io.codedrills.proto.judge.NestedType.prototype.setInnerTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.ArgType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.ArgType}
 */
proto.io.codedrills.proto.judge.NestedType.prototype.addInnerTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.judge.ArgType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.NestedType} returns this
 */
proto.io.codedrills.proto.judge.NestedType.prototype.clearInnerTypesList = function() {
  return this.setInnerTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.ProblemKey.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.ProblemKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.ProblemKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ProblemKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.ProblemKey}
 */
proto.io.codedrills.proto.judge.ProblemKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.ProblemKey;
  return proto.io.codedrills.proto.judge.ProblemKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.ProblemKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.ProblemKey}
 */
proto.io.codedrills.proto.judge.ProblemKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.ProblemKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.ProblemKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.ProblemKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ProblemKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeFixed32(
      2,
      f
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemKey.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemKey} returns this
 */
proto.io.codedrills.proto.judge.ProblemKey.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional fixed32 version = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.ProblemKey.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.ProblemKey} returns this
 */
proto.io.codedrills.proto.judge.ProblemKey.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.TestKey.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.TestKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.TestKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    testSet: jspb.Message.getFieldWithDefault(msg, 2, ""),
    testCase: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.TestKey}
 */
proto.io.codedrills.proto.judge.TestKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.TestKey;
  return proto.io.codedrills.proto.judge.TestKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.TestKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.TestKey}
 */
proto.io.codedrills.proto.judge.TestKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSubmissionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestSet(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTestCase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.TestKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.TestKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.TestKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getTestSet();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTestCase();
  if (f !== 0) {
    writer.writeFixed32(
      3,
      f
    );
  }
};


/**
 * optional fixed32 submission_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.TestKey.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.TestKey} returns this
 */
proto.io.codedrills.proto.judge.TestKey.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string test_set = 2;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestKey.prototype.getTestSet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestKey} returns this
 */
proto.io.codedrills.proto.judge.TestKey.prototype.setTestSet = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional fixed32 test_case = 3;
 * @return {number}
 */
proto.io.codedrills.proto.judge.TestKey.prototype.getTestCase = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.TestKey} returns this
 */
proto.io.codedrills.proto.judge.TestKey.prototype.setTestCase = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.CompileResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.CompileResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.CompileResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemKey: (f = msg.getProblemKey()) && proto.io.codedrills.proto.judge.ProblemKey.toObject(includeInstance, f),
    submissionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    result: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.CompileResult}
 */
proto.io.codedrills.proto.judge.CompileResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.CompileResult;
  return proto.io.codedrills.proto.judge.CompileResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.CompileResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.CompileResult}
 */
proto.io.codedrills.proto.judge.CompileResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.judge.ProblemKey;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ProblemKey.deserializeBinaryFromReader);
      msg.setProblemKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSubmissionId(value);
      break;
    case 3:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.CompileResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.CompileResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.CompileResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemKey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.judge.ProblemKey.serializeBinaryToWriter
    );
  }
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeFixed32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional ProblemKey problem_key = 1;
 * @return {?proto.io.codedrills.proto.judge.ProblemKey}
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.getProblemKey = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ProblemKey} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ProblemKey, 1));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ProblemKey|undefined} value
 * @return {!proto.io.codedrills.proto.judge.CompileResult} returns this
*/
proto.io.codedrills.proto.judge.CompileResult.prototype.setProblemKey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.CompileResult} returns this
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.clearProblemKey = function() {
  return this.setProblemKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.hasProblemKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fixed32 submission_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.CompileResult} returns this
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Status status = 3;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.judge.CompileResult} returns this
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string result = 4;
 * @return {string}
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.CompileResult} returns this
 */
proto.io.codedrills.proto.judge.CompileResult.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.TestRunRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.TestRunRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.TestRunRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestRunRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemKey: (f = msg.getProblemKey()) && proto.io.codedrills.proto.judge.ProblemKey.toObject(includeInstance, f),
    testKey: (f = msg.getTestKey()) && proto.io.codedrills.proto.judge.TestKey.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.TestRunRequest}
 */
proto.io.codedrills.proto.judge.TestRunRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.TestRunRequest;
  return proto.io.codedrills.proto.judge.TestRunRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.TestRunRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.TestRunRequest}
 */
proto.io.codedrills.proto.judge.TestRunRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.judge.ProblemKey;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ProblemKey.deserializeBinaryFromReader);
      msg.setProblemKey(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.TestKey;
      reader.readMessage(value,proto.io.codedrills.proto.judge.TestKey.deserializeBinaryFromReader);
      msg.setTestKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.TestRunRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.TestRunRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.TestRunRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestRunRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemKey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.judge.ProblemKey.serializeBinaryToWriter
    );
  }
  f = message.getTestKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.TestKey.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProblemKey problem_key = 1;
 * @return {?proto.io.codedrills.proto.judge.ProblemKey}
 */
proto.io.codedrills.proto.judge.TestRunRequest.prototype.getProblemKey = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ProblemKey} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ProblemKey, 1));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ProblemKey|undefined} value
 * @return {!proto.io.codedrills.proto.judge.TestRunRequest} returns this
*/
proto.io.codedrills.proto.judge.TestRunRequest.prototype.setProblemKey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestRunRequest} returns this
 */
proto.io.codedrills.proto.judge.TestRunRequest.prototype.clearProblemKey = function() {
  return this.setProblemKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestRunRequest.prototype.hasProblemKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TestKey test_key = 2;
 * @return {?proto.io.codedrills.proto.judge.TestKey}
 */
proto.io.codedrills.proto.judge.TestRunRequest.prototype.getTestKey = function() {
  return /** @type{?proto.io.codedrills.proto.judge.TestKey} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.TestKey, 2));
};


/**
 * @param {?proto.io.codedrills.proto.judge.TestKey|undefined} value
 * @return {!proto.io.codedrills.proto.judge.TestRunRequest} returns this
*/
proto.io.codedrills.proto.judge.TestRunRequest.prototype.setTestKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestRunRequest} returns this
 */
proto.io.codedrills.proto.judge.TestRunRequest.prototype.clearTestKey = function() {
  return this.setTestKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestRunRequest.prototype.hasTestKey = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.TestRunResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.TestRunResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestRunResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    testKey: (f = msg.getTestKey()) && proto.io.codedrills.proto.judge.TestKey.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    result: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timeTakenInMs: jspb.Message.getFieldWithDefault(msg, 5, 0),
    memoryTakenInKb: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.TestRunResult}
 */
proto.io.codedrills.proto.judge.TestRunResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.TestRunResult;
  return proto.io.codedrills.proto.judge.TestRunResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.TestRunResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.TestRunResult}
 */
proto.io.codedrills.proto.judge.TestRunResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSubmissionId(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.TestKey;
      reader.readMessage(value,proto.io.codedrills.proto.judge.TestKey.deserializeBinaryFromReader);
      msg.setTestKey(value);
      break;
    case 3:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeTakenInMs(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemoryTakenInKb(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.TestRunResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.TestRunResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestRunResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getTestKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.TestKey.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimeTakenInMs();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMemoryTakenInKb();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional fixed32 submission_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.TestRunResult} returns this
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TestKey test_key = 2;
 * @return {?proto.io.codedrills.proto.judge.TestKey}
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.getTestKey = function() {
  return /** @type{?proto.io.codedrills.proto.judge.TestKey} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.TestKey, 2));
};


/**
 * @param {?proto.io.codedrills.proto.judge.TestKey|undefined} value
 * @return {!proto.io.codedrills.proto.judge.TestRunResult} returns this
*/
proto.io.codedrills.proto.judge.TestRunResult.prototype.setTestKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestRunResult} returns this
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.clearTestKey = function() {
  return this.setTestKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.hasTestKey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Status status = 3;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.judge.TestRunResult} returns this
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string result = 4;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestRunResult} returns this
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 time_taken_in_ms = 5;
 * @return {number}
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.getTimeTakenInMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.TestRunResult} returns this
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.setTimeTakenInMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 memory_taken_in_kb = 6;
 * @return {number}
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.getMemoryTakenInKb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.TestRunResult} returns this
 */
proto.io.codedrills.proto.judge.TestRunResult.prototype.setMemoryTakenInKb = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.Submission.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.Submission.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.Submission} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.Submission.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    problemKey: (f = msg.getProblemKey()) && proto.io.codedrills.proto.judge.ProblemKey.toObject(includeInstance, f),
    language: jspb.Message.getFieldWithDefault(msg, 3, 0),
    code: jspb.Message.getFieldWithDefault(msg, 4, ""),
    submissionType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    timeTakenInMs: jspb.Message.getFieldWithDefault(msg, 6, 0),
    memoryTakenInKb: jspb.Message.getFieldWithDefault(msg, 7, 0),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    firstIncorrectTestSet: jspb.Message.getFieldWithDefault(msg, 9, ""),
    firstIncorrectTestId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    submittedOn: jspb.Message.getFieldWithDefault(msg, 11, 0),
    submittedBy: jspb.Message.getFieldWithDefault(msg, 12, ""),
    runId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    submissionVisibility: jspb.Message.getFieldWithDefault(msg, 14, 0),
    parentId: jspb.Message.getFieldWithDefault(msg, 15, 0),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.Submission}
 */
proto.io.codedrills.proto.judge.Submission.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.Submission;
  return proto.io.codedrills.proto.judge.Submission.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.Submission} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.Submission}
 */
proto.io.codedrills.proto.judge.Submission.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.ProblemKey;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ProblemKey.deserializeBinaryFromReader);
      msg.setProblemKey(value);
      break;
    case 3:
      var value = /** @type {!proto.io.codedrills.proto.judge.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (reader.readEnum());
      msg.setSubmissionType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeTakenInMs(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemoryTakenInKb(value);
      break;
    case 8:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstIncorrectTestSet(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setFirstIncorrectTestId(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedOn(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedBy(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRunId(value);
      break;
    case 14:
      var value = /** @type {!proto.io.codedrills.proto.content.SubmissionVisibility} */ (reader.readEnum());
      msg.setSubmissionVisibility(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParentId(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.Submission.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.Submission.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.Submission} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.Submission.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getProblemKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.ProblemKey.serializeBinaryToWriter
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubmissionType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTimeTakenInMs();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMemoryTakenInKb();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getFirstIncorrectTestSet();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFirstIncorrectTestId();
  if (f !== 0) {
    writer.writeFixed32(
      10,
      f
    );
  }
  f = message.getSubmittedOn();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getSubmittedBy();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getRunId();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getSubmissionVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getParentId();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
};


/**
 * optional fixed32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ProblemKey problem_key = 2;
 * @return {?proto.io.codedrills.proto.judge.ProblemKey}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getProblemKey = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ProblemKey} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ProblemKey, 2));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ProblemKey|undefined} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
*/
proto.io.codedrills.proto.judge.Submission.prototype.setProblemKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.clearProblemKey = function() {
  return this.setProblemKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.Submission.prototype.hasProblemKey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Language language = 3;
 * @return {!proto.io.codedrills.proto.judge.Language}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getLanguage = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Language} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string code = 4;
 * @return {string}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional SubmissionType submission_type = 5;
 * @return {!proto.io.codedrills.proto.judge.SubmissionType}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getSubmissionType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.SubmissionType} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setSubmissionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int32 time_taken_in_ms = 6;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getTimeTakenInMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setTimeTakenInMs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 memory_taken_in_kb = 7;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getMemoryTakenInKb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setMemoryTakenInKb = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional Status status = 8;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string first_incorrect_test_set = 9;
 * @return {string}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getFirstIncorrectTestSet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setFirstIncorrectTestSet = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional fixed32 first_incorrect_test_id = 10;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getFirstIncorrectTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setFirstIncorrectTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 submitted_on = 11;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getSubmittedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setSubmittedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string submitted_by = 12;
 * @return {string}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getSubmittedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setSubmittedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int32 run_id = 13;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getRunId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setRunId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional io.codedrills.proto.content.SubmissionVisibility submission_visibility = 14;
 * @return {!proto.io.codedrills.proto.content.SubmissionVisibility}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getSubmissionVisibility = function() {
  return /** @type {!proto.io.codedrills.proto.content.SubmissionVisibility} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.SubmissionVisibility} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setSubmissionVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional int32 parent_id = 15;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getParentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setParentId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional double score = 16;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Submission.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Submission} returns this
 */
proto.io.codedrills.proto.judge.Submission.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.SubmissionSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.SubmissionSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.SubmissionSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    problemKey: (f = msg.getProblemKey()) && proto.io.codedrills.proto.judge.ProblemKey.toObject(includeInstance, f),
    language: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    submittedOn: jspb.Message.getFieldWithDefault(msg, 5, 0),
    submittedBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.SubmissionSummary;
  return proto.io.codedrills.proto.judge.SubmissionSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.SubmissionSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.ProblemKey;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ProblemKey.deserializeBinaryFromReader);
      msg.setProblemKey(value);
      break;
    case 3:
      var value = /** @type {!proto.io.codedrills.proto.judge.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedOn(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedBy(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.SubmissionSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.SubmissionSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.SubmissionSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getProblemKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.ProblemKey.serializeBinaryToWriter
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSubmittedOn();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSubmittedBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional fixed32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary} returns this
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ProblemKey problem_key = 2;
 * @return {?proto.io.codedrills.proto.judge.ProblemKey}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.getProblemKey = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ProblemKey} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ProblemKey, 2));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ProblemKey|undefined} value
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary} returns this
*/
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.setProblemKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary} returns this
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.clearProblemKey = function() {
  return this.setProblemKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.hasProblemKey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Language language = 3;
 * @return {!proto.io.codedrills.proto.judge.Language}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.getLanguage = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Language} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary} returns this
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Status status = 4;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary} returns this
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 submitted_on = 5;
 * @return {number}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.getSubmittedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary} returns this
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.setSubmittedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string submitted_by = 6;
 * @return {string}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.getSubmittedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary} returns this
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.setSubmittedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional double score = 7;
 * @return {number}
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary} returns this
 */
proto.io.codedrills.proto.judge.SubmissionSummary.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.CompileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.CompileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.CompileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.CompileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemKey: (f = msg.getProblemKey()) && proto.io.codedrills.proto.judge.ProblemKey.toObject(includeInstance, f),
    submissionId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.CompileRequest}
 */
proto.io.codedrills.proto.judge.CompileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.CompileRequest;
  return proto.io.codedrills.proto.judge.CompileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.CompileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.CompileRequest}
 */
proto.io.codedrills.proto.judge.CompileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.judge.ProblemKey;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ProblemKey.deserializeBinaryFromReader);
      msg.setProblemKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSubmissionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.CompileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.CompileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.CompileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.CompileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemKey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.judge.ProblemKey.serializeBinaryToWriter
    );
  }
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeFixed32(
      2,
      f
    );
  }
};


/**
 * optional ProblemKey problem_key = 1;
 * @return {?proto.io.codedrills.proto.judge.ProblemKey}
 */
proto.io.codedrills.proto.judge.CompileRequest.prototype.getProblemKey = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ProblemKey} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ProblemKey, 1));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ProblemKey|undefined} value
 * @return {!proto.io.codedrills.proto.judge.CompileRequest} returns this
*/
proto.io.codedrills.proto.judge.CompileRequest.prototype.setProblemKey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.CompileRequest} returns this
 */
proto.io.codedrills.proto.judge.CompileRequest.prototype.clearProblemKey = function() {
  return this.setProblemKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.CompileRequest.prototype.hasProblemKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fixed32 submission_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.CompileRequest.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.CompileRequest} returns this
 */
proto.io.codedrills.proto.judge.CompileRequest.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.Rejudge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.Rejudge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.Rejudge.toObject = function(includeInstance, msg) {
  var f, obj = {
    runId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    contentId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    contentVersion: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    submittedOn: jspb.Message.getFieldWithDefault(msg, 5, 0),
    submittedBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
    updatedOn: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.Rejudge}
 */
proto.io.codedrills.proto.judge.Rejudge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.Rejudge;
  return proto.io.codedrills.proto.judge.Rejudge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.Rejudge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.Rejudge}
 */
proto.io.codedrills.proto.judge.Rejudge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRunId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentVersion(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.judge.RejudgeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedOn(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedBy(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.Rejudge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.Rejudge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.Rejudge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRunId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getContentVersion();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSubmittedOn();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSubmittedBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUpdatedOn();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int32 run_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.getRunId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Rejudge} returns this
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.setRunId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 content_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Rejudge} returns this
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 content_version = 3;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.getContentVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Rejudge} returns this
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.setContentVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional RejudgeStatus status = 4;
 * @return {!proto.io.codedrills.proto.judge.RejudgeStatus}
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.RejudgeStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.RejudgeStatus} value
 * @return {!proto.io.codedrills.proto.judge.Rejudge} returns this
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 submitted_on = 5;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.getSubmittedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Rejudge} returns this
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.setSubmittedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string submitted_by = 6;
 * @return {string}
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.getSubmittedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.Rejudge} returns this
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.setSubmittedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 updated_on = 7;
 * @return {number}
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.getUpdatedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.Rejudge} returns this
 */
proto.io.codedrills.proto.judge.Rejudge.prototype.setUpdatedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.TestResultView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.TestResultView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestResultView.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    inputView: (f = msg.getInputView()) && proto.io.codedrills.proto.judge.TestInputView.toObject(includeInstance, f),
    expectedView: (f = msg.getExpectedView()) && proto.io.codedrills.proto.judge.TestOutputView.toObject(includeInstance, f),
    actualView: (f = msg.getActualView()) && proto.io.codedrills.proto.judge.TestOutputView.toObject(includeInstance, f),
    logs: jspb.Message.getFieldWithDefault(msg, 5, ""),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.TestResultView}
 */
proto.io.codedrills.proto.judge.TestResultView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.TestResultView;
  return proto.io.codedrills.proto.judge.TestResultView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.TestResultView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.TestResultView}
 */
proto.io.codedrills.proto.judge.TestResultView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.TestInputView;
      reader.readMessage(value,proto.io.codedrills.proto.judge.TestInputView.deserializeBinaryFromReader);
      msg.setInputView(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.judge.TestOutputView;
      reader.readMessage(value,proto.io.codedrills.proto.judge.TestOutputView.deserializeBinaryFromReader);
      msg.setExpectedView(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.judge.TestOutputView;
      reader.readMessage(value,proto.io.codedrills.proto.judge.TestOutputView.deserializeBinaryFromReader);
      msg.setActualView(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogs(value);
      break;
    case 6:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.TestResultView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.TestResultView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestResultView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getInputView();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.TestInputView.serializeBinaryToWriter
    );
  }
  f = message.getExpectedView();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.judge.TestOutputView.serializeBinaryToWriter
    );
  }
  f = message.getActualView();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.io.codedrills.proto.judge.TestOutputView.serializeBinaryToWriter
    );
  }
  f = message.getLogs();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.TestResultView} returns this
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TestInputView input_view = 2;
 * @return {?proto.io.codedrills.proto.judge.TestInputView}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.getInputView = function() {
  return /** @type{?proto.io.codedrills.proto.judge.TestInputView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.TestInputView, 2));
};


/**
 * @param {?proto.io.codedrills.proto.judge.TestInputView|undefined} value
 * @return {!proto.io.codedrills.proto.judge.TestResultView} returns this
*/
proto.io.codedrills.proto.judge.TestResultView.prototype.setInputView = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestResultView} returns this
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.clearInputView = function() {
  return this.setInputView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.hasInputView = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TestOutputView expected_view = 3;
 * @return {?proto.io.codedrills.proto.judge.TestOutputView}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.getExpectedView = function() {
  return /** @type{?proto.io.codedrills.proto.judge.TestOutputView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.TestOutputView, 3));
};


/**
 * @param {?proto.io.codedrills.proto.judge.TestOutputView|undefined} value
 * @return {!proto.io.codedrills.proto.judge.TestResultView} returns this
*/
proto.io.codedrills.proto.judge.TestResultView.prototype.setExpectedView = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestResultView} returns this
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.clearExpectedView = function() {
  return this.setExpectedView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.hasExpectedView = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TestOutputView actual_view = 4;
 * @return {?proto.io.codedrills.proto.judge.TestOutputView}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.getActualView = function() {
  return /** @type{?proto.io.codedrills.proto.judge.TestOutputView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.TestOutputView, 4));
};


/**
 * @param {?proto.io.codedrills.proto.judge.TestOutputView|undefined} value
 * @return {!proto.io.codedrills.proto.judge.TestResultView} returns this
*/
proto.io.codedrills.proto.judge.TestResultView.prototype.setActualView = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestResultView} returns this
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.clearActualView = function() {
  return this.setActualView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.hasActualView = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string logs = 5;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.getLogs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestResultView} returns this
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.setLogs = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Status status = 6;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.judge.TestResultView} returns this
 */
proto.io.codedrills.proto.judge.TestResultView.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.TestOutputView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.TestOutputView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.TestOutputView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestOutputView.toObject = function(includeInstance, msg) {
  var f, obj = {
    rawOutput: jspb.Message.getFieldWithDefault(msg, 1, ""),
    argOutputView: (f = msg.getArgOutputView()) && proto.io.codedrills.proto.judge.ArgView.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.TestOutputView}
 */
proto.io.codedrills.proto.judge.TestOutputView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.TestOutputView;
  return proto.io.codedrills.proto.judge.TestOutputView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.TestOutputView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.TestOutputView}
 */
proto.io.codedrills.proto.judge.TestOutputView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRawOutput(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.ArgView;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ArgView.deserializeBinaryFromReader);
      msg.setArgOutputView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.TestOutputView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.TestOutputView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.TestOutputView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestOutputView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRawOutput();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArgOutputView();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.ArgView.serializeBinaryToWriter
    );
  }
};


/**
 * optional string raw_output = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestOutputView.prototype.getRawOutput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestOutputView} returns this
 */
proto.io.codedrills.proto.judge.TestOutputView.prototype.setRawOutput = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ArgView arg_output_view = 2;
 * @return {?proto.io.codedrills.proto.judge.ArgView}
 */
proto.io.codedrills.proto.judge.TestOutputView.prototype.getArgOutputView = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ArgView} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ArgView, 2));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ArgView|undefined} value
 * @return {!proto.io.codedrills.proto.judge.TestOutputView} returns this
*/
proto.io.codedrills.proto.judge.TestOutputView.prototype.setArgOutputView = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.TestOutputView} returns this
 */
proto.io.codedrills.proto.judge.TestOutputView.prototype.clearArgOutputView = function() {
  return this.setArgOutputView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.TestOutputView.prototype.hasArgOutputView = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.TestInputView.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.TestInputView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.TestInputView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.TestInputView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestInputView.toObject = function(includeInstance, msg) {
  var f, obj = {
    rawInput: jspb.Message.getFieldWithDefault(msg, 1, ""),
    argInputViewsList: jspb.Message.toObjectList(msg.getArgInputViewsList(),
    proto.io.codedrills.proto.judge.ArgView.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.TestInputView}
 */
proto.io.codedrills.proto.judge.TestInputView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.TestInputView;
  return proto.io.codedrills.proto.judge.TestInputView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.TestInputView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.TestInputView}
 */
proto.io.codedrills.proto.judge.TestInputView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRawInput(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.ArgView;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ArgView.deserializeBinaryFromReader);
      msg.addArgInputViews(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.TestInputView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.TestInputView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.TestInputView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.TestInputView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRawInput();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArgInputViewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.ArgView.serializeBinaryToWriter
    );
  }
};


/**
 * optional string raw_input = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.TestInputView.prototype.getRawInput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.TestInputView} returns this
 */
proto.io.codedrills.proto.judge.TestInputView.prototype.setRawInput = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ArgView arg_input_views = 2;
 * @return {!Array<!proto.io.codedrills.proto.judge.ArgView>}
 */
proto.io.codedrills.proto.judge.TestInputView.prototype.getArgInputViewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.ArgView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.judge.ArgView, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.ArgView>} value
 * @return {!proto.io.codedrills.proto.judge.TestInputView} returns this
*/
proto.io.codedrills.proto.judge.TestInputView.prototype.setArgInputViewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.ArgView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.ArgView}
 */
proto.io.codedrills.proto.judge.TestInputView.prototype.addArgInputViews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.judge.ArgView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.TestInputView} returns this
 */
proto.io.codedrills.proto.judge.TestInputView.prototype.clearArgInputViewsList = function() {
  return this.setArgInputViewsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.ArgView.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.ArgView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.ArgView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ArgView.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: (f = msg.getType()) && proto.io.codedrills.proto.judge.ArgType.toObject(includeInstance, f),
    value: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.ArgView}
 */
proto.io.codedrills.proto.judge.ArgView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.ArgView;
  return proto.io.codedrills.proto.judge.ArgView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.ArgView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.ArgView}
 */
proto.io.codedrills.proto.judge.ArgView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.ArgType;
      reader.readMessage(value,proto.io.codedrills.proto.judge.ArgType.deserializeBinaryFromReader);
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.ArgView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.ArgView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.ArgView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.ArgView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.ArgType.serializeBinaryToWriter
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.ArgView.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.ArgView} returns this
 */
proto.io.codedrills.proto.judge.ArgView.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ArgType type = 2;
 * @return {?proto.io.codedrills.proto.judge.ArgType}
 */
proto.io.codedrills.proto.judge.ArgView.prototype.getType = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ArgType} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.judge.ArgType, 2));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ArgType|undefined} value
 * @return {!proto.io.codedrills.proto.judge.ArgView} returns this
*/
proto.io.codedrills.proto.judge.ArgView.prototype.setType = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.ArgView} returns this
 */
proto.io.codedrills.proto.judge.ArgView.prototype.clearType = function() {
  return this.setType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.ArgView.prototype.hasType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.io.codedrills.proto.judge.ArgView.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.ArgView} returns this
 */
proto.io.codedrills.proto.judge.ArgView.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.RejudgeSubmission.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.RejudgeSubmission} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    runId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    contentId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    contentVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.RejudgeSubmission}
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.RejudgeSubmission;
  return proto.io.codedrills.proto.judge.RejudgeSubmission.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.RejudgeSubmission} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.RejudgeSubmission}
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubmissionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRunId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.RejudgeSubmission.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.RejudgeSubmission} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRunId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getContentVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 submission_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.RejudgeSubmission} returns this
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 run_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.getRunId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.RejudgeSubmission} returns this
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.setRunId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 content_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.RejudgeSubmission} returns this
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 content_version = 4;
 * @return {number}
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.getContentVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.RejudgeSubmission} returns this
 */
proto.io.codedrills.proto.judge.RejudgeSubmission.prototype.setContentVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.Language = {
  TEXT: 0,
  CPP_17: 1,
  JAVA_11: 2,
  PYTHON_3: 3,
  KOTLIN_1_3: 4,
  MY_SQL_8: 5,
  JAVASCRIPT: 6
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.Status = {
  WAITING: 0,
  COMPILING: 1,
  COMPILED: 2,
  RUNNING: 3,
  COMPILE_ERROR: 10,
  RUNTIME_ERROR: 11,
  TIME_LIMIT_EXCEEDED: 12,
  CORRECT_ANSWER: 13,
  WRONG_ANSWER: 14,
  SOURCE_LIMIT_EXCEEDED: 15,
  MEMORY_LIMIT_EXCEEDED: 16,
  SKIPPED: 17,
  OUTPUT_LIMIT_EXCEEDED: 18,
  JUDGE_ERROR: 30
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.TestTag = {
  UNKNOWN_TEST_TAG: 0,
  EDGE_TEST: 1,
  STRESS_TEST: 2,
  RANDOM_TEST: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.Difficulty = {
  EASY: 0,
  MEDIUM: 1,
  HARD: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.CompositeType = {
  ARRAY: 0,
  LIST: 1,
  TREE: 2,
  BINARY_TREE: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.PrimitiveType = {
  INT32: 0,
  INT64: 1,
  DOUBLE: 2,
  STRING: 3,
  BOOLEAN: 4
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.ProblemType = {
  BINARY: 0,
  PARTIAL: 1
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.EvaluationType = {
  EVALUATION_TYPE_DEFAULT: 0,
  EVALUATION_TYPE_SQL: 1,
  EVALUATION_TYPE_LIBRARY: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.IOType = {
  UNKNOWN: 0,
  FILE: 1,
  WRAPPED: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.SubmissionType = {
  FULL: 0,
  SAMPLE: 1,
  USER_INPUT: 2,
  TEST_FULL: 3,
  TEST_SAMPLE: 4,
  TEST_USER_INPUT: 5
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.judge.RejudgeStatus = {
  UNKNOWN_REJUDGE_STATUS: 0,
  REJUDGE_STARTED: 1,
  REJUDGE_COMPLETED: 2
};

goog.object.extend(exports, proto.io.codedrills.proto.judge);
